import { useProveedores } from "@/hooks/useProveedores";
import { LoadingScreen } from "@/components/layout/LoadingScreen";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, Users } from "lucide-react";

export const ProveedoresTab = () => {
  const { suppliers, loading, showNew, setShowNew, form, setForm, createSupplier } = useProveedores();

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <p className="text-sm text-muted-foreground">Gestiona tus proveedores</p>
        <Dialog open={showNew} onOpenChange={setShowNew}>
          <DialogTrigger asChild>
            <Button className="gap-2 glow-orange"><Plus className="w-4 h-4" />Nuevo Proveedor</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nuevo Proveedor</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <Input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Nombre" className="bg-secondary border-transparent" />
              <Input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="Teléfono" className="bg-secondary border-transparent" />
              <Input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="Email" className="bg-secondary border-transparent" />
              <Input value={form.category} onChange={e => setForm({ ...form, category: e.target.value })} placeholder="Categoría" className="bg-secondary border-transparent" />
            </div>
            <DialogFooter><Button onClick={createSupplier}>Crear</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      {loading ? <LoadingScreen /> : (
        <div className="grid gap-3">
          {suppliers.map(s => (
            <Card key={s.id} className="card-hover">
              <CardContent className="flex items-center justify-between p-4">
                <div>
                  <p className="font-medium">{s.name}</p>
                  <p className="text-sm text-muted-foreground">{s.phone}{s.email && ` • ${s.email}`}</p>
                </div>
                {s.category && <Badge variant="outline">{s.category}</Badge>}
              </CardContent>
            </Card>
          ))}
          {suppliers.length === 0 && (
            <Card>
              <CardContent className="py-12 text-center">
                <Users className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
                <p className="text-muted-foreground">Sin proveedores</p>
              </CardContent>
            </Card>
          )}
        </div>
      )}
    </div>
  );
};
